import ApiService from './api.service'

const OutputService = {
  pdfListOutput: async function(data) {
    try {
      const options = {
        method: 'post',
        url: '/salidas/list-pdf',
        data: data,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  excelListOutput: async function(data) {
    try {
      const options = {
        method: 'post',
        url: '/salidas/list-excel',
        data: data,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  storeOutput: async function(data) {
    try {
      const response = await ApiService.post('/salidas', data)
      return response
    } catch (error) {
      throw error
    }
  },

  editOutput: async function(id) {
    try {
      const response = await ApiService.get(`salidas/${id}/edit`)
      return response
    } catch (error) {
      throw error
    }
  },

  updateOutput: async function(id, data) {
    try {
      const response = await ApiService.put(`salidas/${id}`, data)
      return response
    } catch (error) {
      throw error
    }
  },

  cancelOutput: async function(id) {
    try {
      const response = await ApiService.delete(`salidas/${id}`)
      return response
    } catch (error) {
      throw error
    }
  },

  showOutput: async function(url) {
    try {
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      throw error
    }
  },

  aprovedOutput: async function(data) {
    try {
      const response = await ApiService.post('/salidas/aprobar', data)
      return response
    } catch (error) {
      throw error
    }
  },

  executedOutput: async function(data) {
    try {
      const response = await ApiService.post('/salidas/ejecutar', data)
      return response
    } catch (error) {
      throw error
    }
  },

  declineOutput: async function(data) {
    try {
      const response = await ApiService.post('/salidas/rechazar', data)
      return response
    } catch (error) {
      throw error
    }
  },

  getDataRentry: async function(id) {
    try {
      const response = await ApiService.post('/reingresos/salida', id)
      return response
    } catch (error) {
      throw error
    }
  },

  storeRentry: async function(data) {
    try {
      const response = await ApiService.post('/reingresos', data)
      return response
    } catch (error) {
      throw error
    }
  },

  showRentry: async function(data) {
    try {
      const response = await ApiService.post('/reingresos/detalle', data)
      return response
    } catch (error) {
      throw error
    }
  },

  downloadOutput: async function(id, type) {
    try {
      const options = {
        method: 'get',
        url: `salidas/descarga/${id}`,
        responseType: 'arraybuffer',
        params: {
          type: type
        }
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  downloadRentry: async function(id) {
    try {
      const options = {
        method: 'get',
        url: `reingresos/descarga/${id}`,
        responseType: 'arraybuffer',
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },
}

export default OutputService